import  { atom } from "recoil";
export const RecoilloadState =  atom({
    key:"isLoading",
    default: false, 
})
export const UserInfoStateRecoil =  atom({
   key: "userInfoState",
   default:{}
});